/* eslint-disable no-eval */
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

export function useQueryString() {
	const history = useHistory();
	const [options, setOptions] = useState<Record<string, string | boolean | number>>({});

	useEffect(() => {
		if(history.location.search) {
			setOptions(Object.fromEntries(history.location.search.slice(1).split('&').map(s => s.split('='))));
		}
	}, []);

	const setState = (data: Record<string, string | boolean | number | null>) => {
		const filtered = Object.entries(data).filter(([_, f]) => Boolean(f));
		history.push(`?${filtered.map(p => p.join('=')).join('&')}`);
	}

	return [options, setState] as const;
}
